import React from 'react';
import Box from '@mui/material/Box';
import { TextField } from '@mui/material';

// export default function Datepicker({ value, onChange, maxDate, minDate,label,required }) {
//     return (
//             <TextField
//                 type='date'
//                 value={value}
//                 fullWidth
//                 size='small'
//                 label={label}
//                 required={required}
//                 InputLabelProps={{ shrink: true }}
//                 id="standard-basic"
//                 variant="standard"
//                 onChange={(e) => onChange(e.target.value)}
//                 InputProps={{
//                     inputProps: {
//                         max: maxDate,
//                         min: minDate,
//                     },
//                 }}
//             />s
//     );
// }

export default function Datepicker({ value, onChange, maxDate, minDate, label, required, error, helperText }) {
    return (
        <TextField
            type="date"
            value={value || ''} // Ensure value is a valid string or empty
            fullWidth
            size="small"
            label={label}
            required={required}
            InputLabelProps={{ shrink: true }}
            variant="standard"
            onChange={(e) => onChange(e.target.value)}
            error={error}
            helperText={helperText}
            InputProps={{
                inputProps: {
                    max: maxDate,
                    min: minDate,
                },
            }}
        />
    );
}

